import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CreditCardRegistration from '../../components/CreditCardRegistration';
import { API_BASE } from '../../lib/config';

const AddCardPage = () => {
  const navigate = useNavigate();
  const [stripePromise, setStripePromise] = React.useState(null);
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // cache-busting to avoid stale pk in CDN/cache
        const res = await fetch(`${API_BASE}/stripe/publishable-key?t=${Date.now()}`);
        if (!res.ok) throw new Error('failed to fetch publishable key');
        const data = await res.json();
        const pk = data?.publishable_key || '';
        if (!pk) throw new Error('Stripe公開鍵が未設定です');
        // debug: show which mode
        try { console.log('[Stripe] publishable key (prefix):', pk.slice(0, 7)); } catch {}
        const promise = loadStripe(pk);
        if (mounted) setStripePromise(promise);
      } catch (e) {
        if (mounted) setError(e?.message || 'Stripeの初期化に失敗しました');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/employer-dashboard')}
          className="text-sm text-gray-600 hover:text-gray-900 mb-4"
        >
          ← ダッシュボードに戻る
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">クレジットカード登録</h1>
        <p className="text-gray-600 mb-6">Stripeで安全にカードを登録します。登録後はダッシュボードに戻ります。</p>

        {loading && (
          <div className="text-sm text-gray-600">読み込み中...</div>
        )}
        {error && !loading && (
          <div className="text-red-600 text-sm mb-4">{error}</div>
        )}
        {stripePromise && (
          <Elements stripe={stripePromise}>
            <CreditCardRegistration onCardRegistered={() => navigate('/employer-dashboard')} />
          </Elements>
        )}
      </div>
    </div>
  );
};

export default AddCardPage;
